/**
 * Story 2 (foundation) — step content stub.
 *
 * Renders an empty-state card explaining which Epic 12 story will
 * deliver the real per-step content. All 9 step bodies use this for
 * now; Stories 3–11 replace this stub one step at a time with the
 * mockup-derived JSX + real backend wiring.
 *
 * Visual: borrows the inline `.emptyState*` classes from StepShell
 * so the placeholder + the locked-step empty state look identical.
 * Sparkle SVG is inlined (Athena convention — no Icon primitive in
 * the v2 surface).
 */
import React from 'react';
import { findStep } from '../state/workflowV2StepCatalog';
import { Icon } from '../../../components/ui/Icon';
import shellStyles from './StepShell.module.css';

// Stories 1 (audit) and 2 (foundation) precede Step 1's implementation
// in Story 3, so step N's story number is N+2.
const storyForStep = (stepId) => `Story ${stepId + 2}`;

export default function StepPlaceholder({ stepId }) {
  const step = findStep(stepId);
  if (!step) return null;
  return (
    <div className={shellStyles.emptyState}>
      <div className={shellStyles.emptyStateIcon}><Icon name="sparkles" size={20} /></div>
      <div className={shellStyles.emptyStateTitle}>
        Step {stepId} content lands in Epic 12 / {storyForStep(stepId)}
      </div>
      <div className={shellStyles.emptyStateDescription}>
        The new {step.title} step body will be wired here against the
        existing backend agent ({step.agent}). For now this is a
        placeholder so the rail navigation, status states, and reviewer
        chat shell can be exercised end-to-end.
      </div>
    </div>
  );
}
